export default {
  black: {
    name: '黑名单',
    tip: '拉黑司机手机号，则该司机无法抢单（本企业货源）；拉黑车辆，则任何司机无法使用该车辆抢单（本企业货源）；',
    delDriverMsg: '是否确认拉黑？拉黑后司机无法在本企业下抢单',
    delCarMsg: '是否确认拉黑？拉黑后该车辆无法在本企业接单',
    apiTypeVal: 1,
    addPathName: 'BlackListAdd',
    mainPathName: 'BlackListControl',
    pathUrl: '/blackListControl',
    driverListPageId: { id: 'logistics_driverBlackList_page', dec: '黑名单管理司机黑名单' },
    plateListPageId: { id: 'logistics_plateBlackList_page', dec: '黑名单管理车辆黑名单' },
    driverListAddDriverBtn: { id: 'logistics_driverBlackList_addDriver_btn', dec: '黑名单管理新增司机黑名单' },
    plateListAddPlateBtn: { id: 'logistics_plateBlackList_addPlate_btn', dec: '黑名单管理新增车辆黑名单' }
  },
  yellow: {
    name: '黄名单',
    tip: '企业可将需要重点监控的司机/车辆加入黄名单，加入黄名单后，可在接单车辆列表的地图模式进行查看（特殊标识）',
    delDriverMsg: '确认添加司机到黄名单',
    delCarMsg: '确认添加车牌到黄名单',
    apiTypeVal: 2,
    addPathName: 'YellowListAdd',
    mainPathName: 'YellowListControl',
    pathUrl: '/yellowListControl',
    driverListPageId: { id: 'logistics_driverYellowList_page', dec: '黄名单管理司机黄名单' },
    plateListPageId: { id: 'logistics_plateYellowList_page', dec: '黄名单管理车辆黄名单' },
    driverListAddDriverBtn: { id: 'logistics_driverYellowList_addDriver_btn', dec: '黄名单管理新增司机黄名单' },
    plateListAddPlateBtn: { id: 'logistics_plateYellowList_addPlate_btn', dec: '黄名单管理新增车辆黄名单' }
  },
  white: {
    name: '白名单',
    tip: '企业可将信任司机/车辆加入白名单，加入白名单后，司机/车辆发生轨迹异常不会进行警告及推送消息',
    delDriverMsg: '确认添加司机到白名单',
    delCarMsg: '确认添加车辆到白名单',
    apiTypeVal: 3,
    addPathName: 'WhiteListAdd',
    mainPathName: 'WhiteListControl',
    pathUrl: '/whiteListControl',
    driverListPageId: { id: 'logistics_driverWhiteList_page', dec: '白名单管理司机白名单' },
    plateListPageId: { id: 'logistics_plateWhiteList_page', dec: '白名单管理车辆白名单' },
    driverListAddDriverBtn: { id: 'logistics_driverWhiteList_addDriver_btn', dec: '白名单管理新增司机白名单' },
    plateListAddPlateBtn: { id: 'logistics_plateWhiteList_addPlate_btn', dec: '白名单管理新增车辆白名单' }
  }
};
